import { useEffect, useState } from "react";
import BASE_URL from "../BASEURL";
import { Link } from "react-router-dom";

export default function Dashboard() {
  const [stats, setStats] = useState({
    categories: 0,
    products: 0,
    orders: 0,
    users: 0,
    pendingOrders: 0,
    totalRevenue: 0,
  });
  const [recentOrders, setRecentOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const [catRes, prodRes, ordRes, userRes] = await Promise.all([
        fetch(`${BASE_URL}/api/category`),
        fetch(`${BASE_URL}/api/product/all`),
        fetch(`${BASE_URL}/api/order`),
        fetch(`${BASE_URL}/api/auth/all`),
      ]);

      const [catData, prodData, ordData, userData] = await Promise.all([
        catRes.json(), prodRes.json(), ordRes.json(), userRes.json()
      ]);

      const categories = Array.isArray(catData) ? catData : catData.data || [];
      const products = Array.isArray(prodData) ? prodData : prodData.data || [];
      const orders = Array.isArray(ordData) ? ordData : ordData.orders || ordData.data || [];
      const users = Array.isArray(userData) ? userData : userData.data || [];

      const pendingOrdersList = orders.filter(o => o.status === "Pending");
      const totalRev = orders.reduce((acc, item) => acc + Number(item.totalPrice || 0), 0);

      setStats({
        categories: categories.length,
        products: products.length,
        orders: orders.length,
        users: users.length,
        pendingOrders: pendingOrdersList.length,
        totalRevenue: totalRev,
      });

      setRecentOrders(pendingOrdersList.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).slice(0, 6));

    } catch (err) {
      console.error("Dashboard Error:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading Dashboard...</div>;

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Admin Dashboard</h1>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8">
        <div className="bg-white p-4 border rounded shadow-sm">
          <p className="text-sm text-gray-500">Categories</p>
          <p className="text-2xl font-bold">{stats.categories}</p>
        </div>
        <div className="bg-white p-4 border rounded shadow-sm">
          <p className="text-sm text-gray-500">Products</p>
          <p className="text-2xl font-bold">{stats.products}</p>
        </div>
        <div className="bg-white p-4 border rounded shadow-sm">
          <p className="text-sm text-gray-500">Total Users</p>
          <p className="text-2xl font-bold">{stats.users}</p>
        </div>
        <div className="bg-white p-4 border rounded shadow-sm">
          <p className="text-sm text-gray-500">Total Orders</p>
          <p className="text-2xl font-bold">{stats.orders}</p>
        </div>
        <div className="bg-white p-4 border rounded shadow-sm">
          <p className="text-sm text-gray-500">Pending Orders</p>
          <p className="text-2xl font-bold text-yellow-600">{stats.pendingOrders}</p>
        </div>
        <div className="bg-white p-4 border rounded shadow-sm">
          <p className="text-sm text-gray-500">Total Revenue</p>
          <p className="text-2xl font-bold text-green-600">₹{stats.totalRevenue}</p>
        </div>
      </div>

      <h2 className="text-xl font-bold mb-4">Recent Pending Orders</h2>
      <div className="bg-white border rounded overflow-x-auto">
        <table className="w-full text-sm text-left border-collapse">
          <thead className="bg-gray-100 border-b">
            <tr>
              <th className="p-2 border-r">Order ID</th>
              <th className="p-2 border-r">Amount</th>
              <th className="p-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {recentOrders.map((o) => (
              <tr key={o._id} className="border-b hover:bg-gray-50">
                <td className="p-2 border-r">{o._id}</td>
                <td className="p-2 border-r">₹{o.totalPrice || 0}</td>
                <td className="p-2 font-bold text-yellow-600">{o.status}</td>
              </tr>
            ))}
            {recentOrders.length === 0 && (
              <tr><td colSpan="4" className="p-4 text-center">No pending orders found.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}